module.exports = __webpack_public_path__ + "static/media/start-left_2.09441594.svg";